import { LOAD_CURBSIDE_SETTINGS_SUCCESS, UPDATE_CURBSIDE_SETTINGS_SUCCESS, RESET_CURBSIDE_SETTINGS } from '../../../../actions/types';

const INITIAL_STATE = []

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOAD_CURBSIDE_SETTINGS_SUCCESS:
            return action.payload;
        case UPDATE_CURBSIDE_SETTINGS_SUCCESS:
            return action.payload;
        case RESET_CURBSIDE_SETTINGS:
            return INITIAL_STATE;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/restaurants/settings/service/CurbsideReducer.js